// Escapes user-provided text before it is interpolated into an HTML string
export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// Only allows http(s) links so a stored "javascript:" URL can't run script
export function safeUrl(value, fallback = '#') {
  try {
    const url = new URL(String(value ?? ''), window.location.href)
    return ['http:', 'https:'].includes(url.protocol) ? url.href : fallback
  } catch {
    return fallback
  }
}
